<app-container class="flex justify-center container" ngClass.xs="xs"
               [maxWidth]="handsetService.isMobile ? '100%' : '552px'"
               [noPadding]="handsetService.isMobile">
  <mat-card class="card" ngClass.xs="xs"
            [ngStyle]="!handsetService.isMobile ? {'padding': '2rem 2rem 1rem 2rem'} : {'padding-top': '0'}">
    <app-add-liability-manual [title]="title" [subtitle]="subtitle"
                              [initialValue]="initialValue"></app-add-liability-manual>
  </mat-card>
</app-container>
